var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotrio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8116 26.8051H23.1662L33.0535 2.70143C33.0535 2.70143 33.674 0.0824139 36.5116 0.0824139C39.3491 0.0824139 46 0 46 0L43.297 39L37.9798 38.912C37.9798 38.912 34.4837 38.7646 35.0125 33.2358C35.5412 27.7069 37.8033 8.67723 37.8033 8.67723L37.5975 8.64791L24.8188 38.9422H20.2361C20.2361 38.9422 17.6803 38.6188 17.0044 35.1186C16.3285 31.6184 13.362 8.67723 13.362 8.67723L13.1269 8.64791L7.83892 38.9128H2.93325C2.93325 38.9128 -0.679918 38.3542 0.113158 34.4126C0.906234 30.471 7.311 0 7.311 0L16.2707 0.0586407C16.2707 0.0586407 19.0322 -0.44139 19.8546 4.61756C20.6769 9.6765 22.8116 26.8051 22.8116 26.8051Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotrio);
export default __webpack_public_path__ + "static/media/motrio.1fbe8874f304f48895ab5fbd96f89fd2.svg";
export { ForwardRef as ReactComponent };